import { render } from "./NFTCard.vue?vue&type=template&id=787323a2&scoped=true&ts=true"
import script from "./NFTCard.vue?vue&type=script&lang=ts"
export * from "./NFTCard.vue?vue&type=script&lang=ts"

import "./NFTCard.vue?vue&type=style&index=0&id=787323a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Domingos\\Documents\\GitHub\\staking-fe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-787323a2"]])

export default __exports__